import axios from 'axios';
import { APIConfigData } from 'core/config/APIConfigData';

export const createPrompt = (
	imageId,
	title,
	keywords,
	image,
	prompt,
	negativePrompt,
	model,
	sampler,
	cfgScale,
	steps,
	aspectRatio,
	seed,
	clipSkip,
	cost,
	hires,
	isPaid,
) =>
	new Promise((resolve, reject) => {
		try {
			axios({
				method: 'POST',
				url: `${APIConfigData.RENDERNET_BASE_URL}/v1/prompt/create`,
				data: {
					image_id: imageId,
					title,
					image,
					prompt,
					negative_prompt: negativePrompt,
					model,
					sampler,
					keywords,
					cfg_scale: cfgScale,
					steps,
					aspect_ratio: aspectRatio,
					seed,
					cost,
					clip_skip: clipSkip,
					hires,
					is_paid: isPaid,
				},
				headers: { 'Content-Type': 'application/json' },
			})
				.then((res) => {
					resolve(res.data.message);
				})
				.catch((error) => {
					reject(error?.response?.data?.err);
				});
		} catch (error) {
			reject(new Error(error.message));
		}
	});
export const toBase64 = (file) =>
	new Promise((resolve, reject) => {
		try {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		} catch (error) {
			reject(new Error(error.message));
		}
	});
